import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { EMPTY, Observable, empty, throwError } from 'rxjs';
import { first, switchMap, catchError } from 'rxjs/operators';
import { getToken } from 'src/app/kiosk/components/authentication/state/authentication.selectors';
import { AppState } from 'src/app/state/app.state';
import { jwtDecode } from 'jwt-decode';
import { TokenResponseModel } from 'src/app/authenticator/models';

@Injectable()
export class AuthInterceptor implements HttpInterceptor, OnDestroy {
  constructor(private router: Router,private store: Store<AppState>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let scopedToken = null;
    return this.store.pipe(select(getToken)).pipe(
      first(),
      switchMap(token => {
        if (token) {
          scopedToken = token;
          const tokenUser = jwtDecode<TokenResponseModel>(token.access_token);
          // Convert utc expiration time into locale time
          const tokenExpired = new Date(+tokenUser.expires_in * 1000) <= new Date();
          if (!tokenExpired) {
            const newHeaders = req.headers.set('Authorization', `${token.token_type} ${token.access_token}`);
            
            const copiedReq = req.clone({ headers: newHeaders });
            return next.handle(copiedReq);
          } else {
            return next.handle(req);
          }
        } else {
          return next.handle(req);
        }
      }),
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          if (scopedToken) {
            const tokenUser = jwtDecode<TokenResponseModel>(scopedToken.access_token);
            // Convert utc expiration time into locale time
            const tokenExpired = new Date(+tokenUser.expires_in * 1000) <= new Date();
            if (tokenExpired === false) {
              this.router.navigate(['/error/forbidden']);
            }
          } 

          // this response is handled
          // stop the chain of handlers by returning empty
          return EMPTY;
        }

        // rethrow so other error handlers may pick this up
        return throwError(() => err);
      })
    );
  }

  ngOnDestroy(): void {}
}
